import React from "react";
import ReactDOM from "react-dom/client";
import { Contractor, getContractorQueryParam } from "@bb/game-products-ui";

import { Provider } from "react-redux";

import "normalize.css";

import reportWebVitals from "./reportWebVitals";

import { App } from "./App";
import { store } from "./store/store";

import "./shared/styles/preset.scss";
import "./shared/styles/preload.scss";
import "./shared/styles/fonts.scss";
import { AudioProvider } from "./contexts";

const contractor = getContractorQueryParam();

switch (contractor) {
  case Contractor.Online:
    import("./shared/styles/online.scss");
    break;
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AudioProvider>
        <App />
      </AudioProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
